import { createFileRoute } from '@tanstack/react-router';
import { fallback, zodSearchValidator } from '@tanstack/router-zod-adapter';
import z from 'zod';

import { queries } from '../common/api/queryKeys/queries';
import { CompanyTabs } from '../company/common/CompanyTabs';
import { SupplierDetailPage } from '../company/supplier/detail/SupplierDetailPage';

const supplierCompanyDetailSearchSchema = z.object({
    tab: fallback(
        z.enum([CompanyTabs.DETAILS, CompanyTabs.SETTINGS, CompanyTabs.COMMUNICATION_PREFERENCES]),
        CompanyTabs.DETAILS
    ).default(CompanyTabs.DETAILS),
});

export const Route = createFileRoute('/_app/supplier-groups/$groupId/companies/$companyId')({
    validateSearch: zodSearchValidator(supplierCompanyDetailSearchSchema),
    component: SupplierDetailPage,
    loader: async ({ params, context }) => {
        return Promise.all([
            context.queryClient.ensureQueryData(queries.suppliers.detail(params.companyId)),
            context.queryClient.prefetchQuery(queries.suppliers.detail(params.companyId)._ctx.settings),
        ]);
    },
});
